export default {
  placeholders: {
    first_name: 'Fornavn',
    last_name: 'Efternavn',
    email: 'E-mail',
    mobile_number: 'Mobilnummer',
  },
  labels: {
    exclusive_offers_via_email: 'Jeg vil gerne modtage eksklusive tilbud og nyheder på e-mail.',
  },
  buttons: {
    sign_up: 'Tilmeld dig',
  },
};
